module.exports = __webpack_public_path__ + "img/edc-gopay.7b23241f.png";